import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';

import { getSanitisedUrl } from '@lyearn/core/utils/url';
import { useTranslation } from '@lyearn/i18n';
import { BookmarkPlaceholder } from '@lyearn/icons';
import { useReactNodeView } from '@lyearn/lygo-core';
import { Box } from '@lyearn/ui';

import { EmbedPopover } from '../../../components/EmbedPopover';
import { WebBookmarkCard } from '../../../components/WebBookmarkCard';
import { WebBookmarkComponentProps } from '../types';
import BookmarkLoader from './Loader';
import { usePreview } from './usePreview';

const FileComponent: React.FC<WebBookmarkComponentProps> = (props) => {
  const { url, title, desc, img, layout, coverImg } = props;
  const { t } = useTranslation();

  const { view, updateAttrs } = useReactNodeView();
  const [localUrl, setLocalUrl] = useState(url && !title ? url : '');

  const setEmbedUrl = useCallback(
    (_parsedUrl: string, embedUrl: string) => {
      setLocalUrl(getSanitisedUrl(embedUrl));
    },
    [setLocalUrl],
  );

  const { preview, fetching } = usePreview(localUrl, {
    pause: !localUrl || !view?.editable,
  });

  useEffect(() => {
    if (!_.isEmpty(preview)) {
      updateAttrs(preview);
    }
  }, [updateAttrs, preview]);

  return (
    <div className="lygo-web-bookmark mt-32">
      {url && title ? (
        <div className="flex w-full justify-center">
          <WebBookmarkCard
            coverImg={coverImg}
            desc={desc}
            img={img}
            layout={layout}
            title={title}
            url={url}
          />
        </div>
      ) : fetching ? (
        <Box className="w-full overflow-hidden rounded-24 border border-border">
          <BookmarkLoader />
        </Box>
      ) : (
        <EmbedPopover
          PlaceholderIcon={BookmarkPlaceholder}
          inputButtonString={t('Common:Actions.Create')}
          inputPlaceholderString={t('Common:Tooltips.Link')}
          isUploadButton={false}
          placeholderString={t('Lygo:AddWebBookMark')}
          setEmbedUrl={setEmbedUrl}
        />
      )}
    </div>
  );
};

export default FileComponent;
